import React, { useContext } from 'react';

import { useConverters } from './../../pm-converters/context';
import { TIPTAP_FIGURE_TYPE } from './../../ricos-content';
import { RicosContext } from './../../ricos-context';
import type { GifNode } from './../../ricos-schema/next-schema';
import type { PluginProps } from './../../ricos-types';

import { getContainerClasses } from '../../_shared/figure/get-container-classes';
import { Giphy } from '../viewer/giphy';

export const Gif: React.FC<PluginProps> = ({ node, editor }) => {
  const { isMobile } = useContext(RicosContext);
  const converters = useConverters();

  const figures = editor.$nodes(TIPTAP_FIGURE_TYPE);
  const selectedFigure = figures?.find(nodePos => {
    return nodePos.node.firstChild?.attrs.id === node.attrs.id;
  })?.node;

  const ricosNode = converters.fromPmNode(selectedFigure?.toJSON()) as GifNode;

  if (!selectedFigure || !ricosNode) {
    return null;
  }

  return (
    <div
      className={getContainerClasses(editor, node.attrs.id, isMobile)}
      draggable
      data-drag-handle
    >
      <Giphy componentData={ricosNode.gifData} nodeId={node.attrs.id} />
    </div>
  );
};
